import { categoryParser } from '../../models/Category'
import * as api from '../api'
import useApiMutation from './useApiMutation'

export interface CreateCategoryArguments {
  name: string
  shortDescription?: string
  longDescription?: string
}

export default function useCreateCategory() {
  return useApiMutation({
    mutationFn: async (data: CreateCategoryArguments) =>
      categoryParser.parse(
        await api.post('category', {
          name: data.name,
          shortDescription: data.shortDescription,
          longDescription: data.longDescription,
        })
      ),
  })
}
